module.exports = __webpack_public_path__ + "img/dianxin6-2.66126a1b.jpg";